import React, {useContext, useEffect, useRef, useState} from 'react';
import Modal from "../../components/Modal";
import {useHttp} from "../../hooks/http.hook";
import {AuthContext} from "../../context/AuthContext";
import {daDataRequest} from "../../api.external/daDataRequest";
import ModalForm from "../../components/Modals/ModalForm/ModalForm";
import LiveSearchInput from "../../components/Inputs/LiveSearchInput/LiveSearchInput";
import FormInput from "../../components/Inputs/FormInput/FormInput";
import RadioCheckInput from "../../components/Inputs/RadioCheckbox/RadioCheckInput";

function OrgSearch(props) {
    const [daData, setDaData] = useState()
    const [formData, setFormData] = useState({
        role: '',
        name: '',
        inn: '',
        kpp: '',
        payed: '',
        address: ''
    })

    const nameRef = useRef()
    const innRef = useRef()
    const kppRef = useRef()
    const addressRef = useRef()


    const daDataInputHandler = (e) => {
        daDataRequest(e.target.value, setDaData)
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const inputHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    function optionClickHandler(kpp, inn) {
        daData.forEach(item => {
            if (item.data?.kpp === kpp && inn === item.data?.inn) {
                innRef.current.value = item.data.inn
                nameRef.current.value = item.data.name?.short
                kppRef.current.value = item.data.kpp
                addressRef.current.value = item.data.address.value

                setFormData({
                    ...formData,
                    name: nameRef.current.value,
                    inn: innRef.current.value,
                    kpp: kppRef.current.value,
                    address: addressRef.current.value
                })

            }
        })
    }

    useEffect(() => {
        if (props.role) {
            setFormData({ ...formData, role: props.role })
        }

    }, [props.data])

    return (
        <Modal>
            <ModalForm
                       onSubmit={false}
                       ready={false}
                       title={'Поиск организации'}>


                <LiveSearchInput optionClickHandler={optionClickHandler}
                                 reff={nameRef}
                                 name={'inn'}
                                 storage={daData}
                                 onChange={daDataInputHandler}
                                 id={'inn'}
                                 title={<>Название <span style={{ color: 'red' }}>*</span></>} />

                <LiveSearchInput optionClickHandler={optionClickHandler}
                                 name={'inn'}
                                 reff={innRef}
                                 storage={daData}
                                 onChange={daDataInputHandler}
                                 id={'inn'}
                                 title={<>ИНН <span style={{ color: 'red' }}>*</span></>} />

                <FormInput onChange={inputHandler} reff={kppRef} name={'kpp'} hideIcon title={'КПП'} />
                <FormInput onChange={inputHandler} reff={addressRef} name={'address'} hideIcon title={'Адрес'} />


            </ModalForm>
        </Modal>
    )
}

export default OrgSearch;